import { State } from '../state';
import { InventoryModState } from './state';
import { getStoreAccessors } from "typesafe-vuex";

export const getters = {
    inventoryItems: (state: InventoryModState) => state.inventoryItems,
    selectedBranchId: (state: InventoryModState) => state.selectedBranchId,
    currentTransactionBatch: (state: InventoryModState) => state.inventoryTransactionBatch,
    currentTransactions: (state: InventoryModState) => state.inventoryTransactions,
};


export const { read } = getStoreAccessors<InventoryModState, State>('');
export const readInventoryItems = read(getters.inventoryItems);
export const readSelectedBranchId = read(getters.selectedBranchId);
export const readCurrentTransactionBatch = read(getters.currentTransactionBatch);
export const readCurrentTransactions = read(getters.currentTransactions);
